import React from "react";
import classes from "./DenMap.module.css";
import { useTranslation } from 'react-i18next';
import Icon from "../../components/UI/Icon/Icon";

const MiniEntry = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation(["misc"]);
    
    return (
        <div className={[classes.Entry, props.cssClass].join(" ")}>
            <div className={classes.Center}><Icon details={props.data} /></div>
            <p><strong>{t("RARITY")}: </strong></p>
            <ul>
                {props.data.Probabilities.map((i, idx) => {
                    return i > 0 ? <li key={idx}>{"☆".repeat(idx+1)}: {i}%</li> : null
                })}
            </ul>
            <p><strong>{t("FLAWLESSIVS")}:</strong> {props.data.FlawlessIVs}</p>
        </div>
        );
};

export default MiniEntry;